import React from "react";
import classes from "./ServicesComponents.module.scss";

const CopyServices = ({ onCopyServices, error }) => {
  return (
    <section className={classes.copyContainer}>
      {!error ? (
        <>
          <p>
            No service credentials have been generated for this company yet.
          </p>
          <button className={classes.generateKey} onClick={onCopyServices}>
            Generate service credentials
          </button>
        </>
      ) : (
        <p>{error}</p>
      )}
    </section>
  );
};

export default CopyServices;
